import { Modal, Button } from "react-bootstrap";
import { format } from "date-fns";
import { useState } from "react";

function CustomerModal({ show, onClose, viewData }) {
    const [activeTab, setActiveTab] = useState("info");

    const styles = {
        row: {
            marginBottom: "10px",
            fontSize: "15px"
        },
        label: {
            fontWeight: 600,
            color: "rgba(1, 41, 112, 0.6)"
        }
    };

    return (
        <Modal show={show} onHide={onClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Customer Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {viewData && (
                    <>
                        {/* Tab Headers */}
                        <ul className="nav nav-tabs nav-tabs-bordered" role="tablist">
                            {[
                                { key: "info", label: "Customer Info" },
                                { key: "metadata", label: "Metadata" }
                            ].map((tab) => (
                                <li className="nav-item" role="presentation" key={tab.key}>
                                    <button
                                        className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                                        type="button"
                                        onClick={() => setActiveTab(tab.key)}
                                    >
                                        {tab.label}
                                    </button>
                                </li>
                            ))}
                        </ul>

                        {/* Tab Content */}
                        <div className="tab-content pt-3 ps-3 pe-3">
                            {activeTab === "info" && (
                                <div className="tab-pane fade show active">
                                    <h5 className="card-title">Customer Info</h5>

                                    <div className="row" style={styles.row}>
                                        <div className="col-lg-3 col-md-4" style={styles.label}>Customer ID</div>
                                        <div className="col-lg-9 col-md-8">{viewData.customer_id}</div>
                                    </div>
                                    <div className="row" style={styles.row}>
                                        <div className="col-lg-3 col-md-4" style={styles.label}>Name</div>
                                        <div className="col-lg-9 col-md-8">{viewData.customer_name}</div>
                                    </div>
                                    <div className="row" style={styles.row}>
                                        <div className="col-lg-3 col-md-4" style={styles.label}>Mobile</div>
                                        <div className="col-lg-9 col-md-8">{viewData.mobile_no}</div>
                                    </div>
                                    <div className="row" style={styles.row}>
                                        <div className="col-lg-3 col-md-4" style={styles.label}>Address</div>
                                        <div className="col-lg-9 col-md-8">{viewData.address || "N/A"}</div>
                                    </div>
                                </div>
                            )}

                            {activeTab === "metadata" && (
                                <div className="tab-pane fade show active">
                                    <h5 className="card-title">Metadata</h5>

                                    <div className="row" style={styles.row}>
                                        <div className="col-lg-3 col-md-4" style={styles.label}>Is Active</div>
                                        <div className="col-lg-9 col-md-8">{viewData.is_active === 1 ? "Yes" : "No"}</div>
                                    </div>
                                    <div className="row" style={styles.row}>
                                        <div className="col-lg-3 col-md-4" style={styles.label}>Created At</div>
                                        <div className="col-lg-9 col-md-8">
                                            {viewData.created_at ? format(new Date(viewData.created_at), "dd-MM-yyyy HH:mm") : "N/A"}
                                        </div>
                                    </div>
                                    <div className="row" style={styles.row}>
                                        <div className="col-lg-3 col-md-4" style={styles.label}>Last Updated</div>
                                        <div className="col-lg-9 col-md-8">
                                            {viewData.last_updated_at ? format(new Date(viewData.last_updated_at), "dd-MM-yyyy HH:mm") : "N/A"}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CustomerModal;
